module.exports = __webpack_public_path__ + "img/643-85bd5f.png";